import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const getProjectType = createAsyncThunk(
    'get-project-type',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/getPPInitiativeType/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

// get project manager list 
export const getProjectManagerList = createAsyncThunk(
    'get-project-manager-list',
    async (payload,{rejectWithValue}) => {
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/GetProjectManagerList`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
// Project/SavePPInitiativeType

export const saveProjectType = createAsyncThunk(
    'save-project-type',
    async (payload,{rejectWithValue}) => {
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SavePPInitiativeType`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

//delete project type
export const deleteProjectType = createAsyncThunk(
    'delete-project-type',
    async (id) => {
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeletePPInitiativeType/${id}`,
                {headers: authHeader()}
            );
            return data;
        }
        catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getProjectRole = createAsyncThunk(
    'get-project-role',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/getProjectRoleDetails/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const saveProjectRole = createAsyncThunk(
    'save-project-role',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/saveProjectRole`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

//delete project role
export const deleteProjectRole = createAsyncThunk(
    'delete-project-role',
    async (id) => {
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteProjectRole/${id}`,
                {headers: authHeader()}
            );
            return data;
        }
        catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getSponsorDetails = createAsyncThunk(
    'get-project-sponsor',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/getPPSponsor/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const saveSponsor = createAsyncThunk(
    'save-project-sponsor',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/savePPSponsor`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const deleteSponsor = createAsyncThunk(
    'delete-sponsor',
    async (id) => {
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeletePPSponsor/${id}`,
                {headers: authHeader()}
            );
            return data;
        }
        catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

// get project method
export const getProjectMethod = createAsyncThunk(
    'get-project-method',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Project/GetPPProjectMethod/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

//save project Method 
export const saveProjectMethod = createAsyncThunk(
    'save-project-method',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SavePPProjectMethod`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

//delete project method
export const deleteProjectMethod = createAsyncThunk(
    'delete-project-method',
    async (id) => {
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeletePPProjectMethod/${id}`,
                {headers: authHeader()}
            );
            return data;
        }
        catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);